import { gql } from '@apollo/client';

export const CANCEL_EVENT = gql`
    mutation cancelEvent($eventId: Int!) {
        cancelEvent(eventId: $eventId) {
            status
        }
    }
`;
